import React from "react";
import "../../styles/PhilosophySection.css";

const PhilosophySection = () => {
  return (
    <section className="philosophy-section">
      <div className="philosophy-container">
        <p className="philosophy-tag">OUR OPERATING PHILOSOPHY</p>

        <h2 className="title-tag"><b>Hospitality Success Isn’t About Working Harder</b></h2>

        <p className="philosophy-sub">
          It’s about building systems that work — consistently.
        </p>

        {/* <div className="philosophy-grid">
          <div>
            <h4>Structure creates clarity.</h4>
            <p>Clarity builds confidence.</p>
          </div> */}
          <div className="value-grid">
          <div className="value-card">
            <p><span className="d"><b>Structure creates clarity.</b></span></p>
            <p>Clarity builds confidence.</p>
          </div>
          </div>
          {/* <div>
            <h4>Confidence enables growth.</h4>
            <p>Growth stops feeling fragile.</p>
          </div> */}
          <div className="value-grid">
          <div className="value-card">
            <p><span className="d"><b>Confidence enables growth.</b></span></p>
            <p>Growth stops feeling fragile.</p>
          </div>
        </div>

        <div className="philosophy-highlight">
          <p><b>
            We don’t stand outside your business giving opinions.  <br />
            We work inside operations — building how your restaurant runs.</b>
          </p>
          <p><b>That’s operating intelligence.</b></p>
          <p><b>We don't work with every restaurant.<br />
           We work with operators who are serious about structure. If you want quick fixes, we are not for you.   </b></p>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
